import { Coins } from "lucide-react";
import Flag from "react-world-flags";

import { cn } from "@/shared/lib/utils";

import { walletFlagCode } from "../../utils/walletsOverview";

export interface CurrencyMarkProps {
  currency: string;
  className?: string;
}

/** The currency's flag (or a coin for crypto and multi-country currencies) next to its code. */
export function CurrencyMark({ currency, className }: CurrencyMarkProps) {
  const flagCode = walletFlagCode(currency);
  return (
    <span className={cn("inline-flex items-center gap-1.5", className)}>
      {flagCode ? (
        <Flag code={flagCode} className="h-3 w-[18px] shrink-0 rounded-[2px] object-cover" aria-hidden />
      ) : (
        <Coins className="size-3.5 shrink-0 text-muted-foreground" aria-hidden />
      )}
      <span className="font-mono text-xs font-medium tracking-wide text-foreground">{currency}</span>
    </span>
  );
}
